import onInitialTableLoadComplete from 'owa-mail-table-loading-actions/lib/actions/onInitialTableLoadComplete';
import loadInitialRowsFromServer from 'owa-mail-list-actions/lib/actions/table/loadInitialRowsFromServer';
import { INITIAL_LOAD_ROW_COUNT } from 'owa-mail-triage-common';
import {
    getGQLPagingInfoForQueryRowsForJumpTo,
    resetTableViewProperties,
    isMailListConversationView,
} from 'owa-mail-list-store';
import type { MailFolderTableQuery, TableView } from 'owa-mail-list-store';
import { logUsage } from 'owa-analytics';
import { getAggregationBucket } from 'owa-analytics-actions';

export default function executeJumpTo(tableView: TableView, matchingString: string) {
    const tableQuery = tableView.tableQuery as MailFolderTableQuery;

    const isConversationView = isMailListConversationView(tableView);

    const customPagingInfo = getGQLPagingInfoForQueryRowsForJumpTo(
        INITIAL_LOAD_ROW_COUNT,
        isConversationView,
        matchingString,
        tableQuery.sortBy
    );

    logUsage('JumpTo_Triggered', {
        sortColumn: tableQuery.sortBy.sortColumn,
        sortOrder: tableQuery.sortBy.sortDirection,
        isConversationView,
        numRowKeysInTable: getAggregationBucket({
            value: tableView.rowKeys.length,
            buckets: [10, 25, 50, 100, 250, 500],
        }),
    });

    resetTableViewProperties(tableView);

    loadInitialRowsFromServer(
        tableView,
        false /*isTablePrefetched*/,
        onInitialTableLoadComplete,
        undefined /*initialSessionData*/,
        false /*skipGqlTimings*/,
        customPagingInfo
    );
}
